// Gold/dark themed color palette and stage color coding
export const GOLD = '#FFD700';
export const DARK_BG = '#181818';
export const DARK_CARD = '#232323';
export const ERROR_RED = '#FF5252';
export const STAGE_COLORS = {
  'Paper Order': '#6A5ACD', // Slate Blue
  'Printing': '#00BFFF', // Deep Sky Blue
  'Lamination': '#20B2AA', // Light Sea Green
  'Post Press': GOLD,
  'Die Cutting': '#FF8C00', // Dark Orange
  'Finishing': '#8B4513', // Saddle Brown
  'Ready for Delivery': '#00C853', // Green
  'Received by Customer': '#FFD700', // Gold
};
// Use ERROR_RED for nearing/overdue dates
